const styles = (theme) => {
  return {
    layout: {
      backgroundColor: theme.AppBGColor,
      flexGrow: 1,
      theme: theme.themeName,
    },
    container: {
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      flex: 1,
      backgroundColor: theme.ModalBGColor,
    },

    main: {
      display: "flex",
      alignContent: "flex-start",
      margin: 0,
      padding: 20,
    },

    radioGroupStyle: {
      paddingTop: 8,
      paddingBottom: 8,
      "&>div": {
        flex: 1,
        width: "100%",
      },
    },
    disableClick: {
      pointerEvents: "none",
    },
    headerStyle: {
      fontSize: "10px",
      color: theme.dispatchPanelHeaderColor,
      lineHeight: "16px",
      fontWeight: 500,
      paddingTop: 8,
      paddingBottom: 8,
      letterSpacing: "1.5px",
    },

    title: {
      fontWeight: 600,
      fontSize: theme.headerTextFontSize,
      color: theme.HeaderSelectedText,
    },
    labelValue: {
      color: theme.dispatchPanelLabelValueColor,
      fontSize: theme.textFontSize,
    },
    headerDivider: {
      backgroundColor: theme.gridIconBorderColor,
      opacity: 0.6,
    },
    divider: {
      backgroundColor: theme.gridIconBorderColor,
      opacity: 0.6,
    },
    contentContainer: {
      position: "relative",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1
    },
  };
};

export default styles;
